export default {
  buyer: {
    cat4mro: {
      title: 'CAT4MRO',
    },
    'request-information': {
      title: 'Solicitudes de Información',
    },
    dashboard: {
      title: 'Tablero',
      description: 'En esta sección podrá encontrar información acerca de su catálogo y actividad',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/routes/buyer.js